import { render, staticRenderFns } from "./ProcedingHistorical.vue?vue&type=template&id=661a2b54&"
import script from "./ProcedingHistorical.vue?vue&type=script&lang=js&"
export * from "./ProcedingHistorical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports